import { ParametersListEntry, ParametersSortOrder, AdminParameterListItemModel, AdminParametersList } from 'types/admin/trackmanParameters';
import { ValidSortProp, dataSorter } from './dataSorters';
import { getLanguageShortText } from './languages';
import { mapBooleanToString } from './booleanMapper';
import dayjs from 'dayjs';

export const getUniquePrimaryCategories = (parametersList: AdminParametersList): string[] => {
  if (!parametersList) {
    return [];
  }
  return ['None', ...new Set(parametersList.map((param) => param.primaryCategory))];
};

export const getFilteredParametersList = (
  parametersList: AdminParametersList,
  sortByProperty: ValidSortProp<AdminParameterListItemModel>,
  sortOrder: ParametersSortOrder,
  searchByNameValue: string,
  searchByCategoryValue: string,
  searchByVisibilityValue: string
): ParametersListEntry[] | undefined => {
  if (!parametersList) {
    return undefined;
  }

  let filtered = [...parametersList];

  if (searchByNameValue) {
    filtered = filtered.filter((param) => param.title.toLowerCase().includes(searchByNameValue.toLowerCase()));
  }

  if (searchByCategoryValue && searchByCategoryValue !== 'None') {
    filtered = filtered.filter((param) => param.primaryCategory.toLowerCase().includes(searchByCategoryValue.toLowerCase()));
  }

  if (searchByVisibilityValue && searchByVisibilityValue !== 'None') {
    filtered = filtered.filter((param) => mapBooleanToString(param.visible).toLowerCase().includes(searchByVisibilityValue.toLowerCase()));
  }

  if (sortByProperty && sortOrder) {
    filtered = dataSorter(filtered, sortByProperty, sortOrder);
  }

  return filtered.map((param) => ({
    id: param.id,
    name: param.title.toLowerCase(),
    primaryCategory: param.primaryCategory,
    languages: param.languages ? param.languages.map((lng) => getLanguageShortText(lng)).join(', ') : '',
    visible: mapBooleanToString(param.visible),
    createdAt: param.createdAt ? dayjs(param.createdAt).format('MMM DD, YYYY') : '',
    updatedAt: param.updatedAt ? dayjs(param.updatedAt).format('MMM DD, YYYY') : '',
  }));
};
